/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://yd24hafzd4.execute-api.eu-central-1.amazonaws.com/prodsweden",
            "region": "eu-central-1"
        },
        {
            "name": "CommonQueries",
            "endpoint": "https://j0nf81xbgg.execute-api.eu-central-1.amazonaws.com/prodsweden",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://tgu5f6diyvg4djt65bhq6lbhzq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-khhgr6lypfbqrddeekzg36zmm4",
    "aws_cognito_identity_pool_id": "eu-central-1:12e73805-c4d3-4967-a608-6211e79ad588",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_jvQqcUcyH",
    "aws_user_pools_web_client_id": "abgiqlk7tp5420f3mqll558ta",
    "oauth": {
        "domain": "content-prodsweden.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "openid",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://content-se.bauermediaoutdoor.com/",
        "redirectSignOut": "https://content-se.bauermediaoutdoor.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 14,
        "passwordPolicyCharacters": [
            "REQUIRES_UPPERCASE",
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "materialportal-assets113309-prodsweden",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
